import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export function DocPreview({ fileId, title, onClose }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!fileId) return undefined;
    let url;
    setSrc(null);
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc({ url, pdf: r.data.type === "application/pdf" }); })
      .catch((e) => { toast.error(errMsg(e)); onClose(); });
    return () => url && URL.revokeObjectURL(url);
  }, [fileId]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={!!fileId} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl bg-card" data-testid="doc-preview-dialog">
        <DialogHeader><DialogTitle>{title || "Document Preview"}</DialogTitle></DialogHeader>
        {!src ? <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin" /></div>
          : src.pdf ? <iframe title="doc" src={src.url} className="h-[70vh] w-full rounded border" data-testid="doc-preview-pdf" />
          : <img src={src.url} alt={title} className="mx-auto max-h-[70vh] rounded object-contain" data-testid="doc-preview-img" />}
        {src && <a href={src.url} target="_blank" rel="noreferrer" className="text-xs font-semibold text-primary hover:underline" data-testid="doc-preview-open-tab">Open in new tab</a>}
      </DialogContent>
    </Dialog>
  );
}

export function DocHistory({ entity, refId, reloadKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { if (refId) api.get("/doc-audit", { params: { entity, ref_id: refId } }).then((r) => setRows(r.data)).catch(() => setRows([])); }, [entity, refId, reloadKey]);
  return (
    <div className="mt-4 rounded-lg border p-3" data-testid="doc-history">
      <div className="mb-2 text-sm font-semibold">Document History (Audit Trail)</div>
      {!rows.length ? <div className="text-xs text-muted-foreground" data-testid="doc-history-empty">No document changes recorded yet</div>
        : <ul className="max-h-48 space-y-1 overflow-auto text-xs">{rows.map((h) => (
          <li key={h.id} data-testid={`doc-history-${h.id}`}><b className="capitalize">{h.action}</b> {h.label}{h.detail ? `: ${h.detail}` : ""} <span className="text-muted-foreground">· {h.by} · {new Date(h.at).toLocaleString("en-IN")}</span></li>
        ))}</ul>}
    </div>
  );
}
